import { RenderViewImpactChartParams } from '@upright/common/renderer/component-types/types-render-view-impact-chart';
import { RenderViewComponentType } from '@upright/common/renderer/types';
import { useGetRenderViewComponentParamSetter } from '../../../context/component-param-setter';
import {
  ControlRoot,
  ControlRowContent,
  ControlRowLabel,
  RadioButton,
  RadioButtonsWrap,
} from '../../../controls/shared';

export const ValueChains = (props: { params: Pick<RenderViewImpactChartParams, 'showValueChains'> }) => {
  const { params } = props;
  const setParams = useGetRenderViewComponentParamSetter(RenderViewComponentType.IMPACT_CHART);

  return (
    <ControlRoot>
      <ControlRowLabel>Value Chains</ControlRowLabel>
      <ControlRowContent>
        <RadioButtonsWrap>
          <RadioButton
            checked={!!params.showValueChains}
            onSelect={() => {
              setParams(curr => ({ ...curr, showValueChains: true }));
            }}
            label={'Show'}
          />
          <RadioButton
            checked={!params.showValueChains}
            onSelect={() => {
              setParams(curr => ({ ...curr, showValueChains: false }));
            }}
            label={'Hide'}
          />
        </RadioButtonsWrap>
      </ControlRowContent>
    </ControlRoot>
  );
};
